import { NavigateFunction, Location } from 'react-router-dom';

interface IAppHistory {
    navigate: NavigateFunction | null;
    location: Location | null;
}

export const history:IAppHistory = {
    navigate: null,
    location: null
};